import React from 'react';
import classNames from 'classnames';
import './DialogTitleActions.less';
import { DialogTitleComponentProps } from './DialogTitle';
import { IconButton } from '@material-ui/core';
import { Fullscreen, FullscreenExit } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';

interface IDialogTitleActionsProps extends DialogTitleComponentProps {
  className?: string;
}

export function DialogTitleActions(props: IDialogTitleActionsProps) {
  const actionButtonClasses = classNames('dp-dialog-title-actions__button', props.classes?.closeButton);
  return (
    <div className={classNames("dp-dialog-title-actions", props.className)}>
      {props.additionalActions}
      {!props.disableFullScreenAction && (
        <IconButton
          aria-label="Fullscreen"
          className={actionButtonClasses}
          style={props.styles?.actionButton}
          onClick={props.onFullScreen}
        >
          {props.isFullScreen ? <FullscreenExit /> : <Fullscreen />}
        </IconButton>
      )}
      <IconButton
        aria-label="close"
        className={actionButtonClasses}
        style={props.styles?.actionButton}
        onClick={props.onClose}
      >
        <CloseIcon className={'dp-dialog-title-actions__close'} />
      </IconButton>
    </div>
  );
}
